module.exports = __webpack_public_path__ + "img/v1-research-mobile.498790d1.png";